import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { FinancialYearDto } from '@nexao/contracts';
import { getCurrentFinancialYear } from '../services/financial-year.service';
import { administrationQueryKeys } from '../queryKeys';

export function useCurrentFinancialYear(): UseQueryResult<FinancialYearDto | null> {
  return useQuery({ queryKey: administrationQueryKeys.currentFinancialYear(), queryFn: getCurrentFinancialYear, staleTime: 5 * 60_000 });
}
